import type { AssistedAffiliationDraftObservation } from "@/services/assistedAffiliation/types";
import { STATUS_BY_LABEL } from "./constants";

type StatusObservationParams = {
  /** Etiqueta en pantalla del estado elegido ("Información pendiente"). */
  statusLabel: string;
  reason: string;
  author: string;
};

/**
 * El motivo de un cambio de estado, como nota del historial de la solicitud. La fecha no viaja: la
 * pone el servicio al guardarla.
 */
export const toStatusObservation = ({
  statusLabel,
  reason,
  author,
}: StatusObservationParams): AssistedAffiliationDraftObservation => ({
  observation: reason.trim(),
  status: STATUS_BY_LABEL[statusLabel],
  created_by: author,
});
